export default __webpack_public_path__ + "static/mykyta-remeslov-3fec7da6e6e92a70589ee7e3b1631be8.png";